export enum PermissionActionType {
  ACTION_SET_ROUTES = 'ACTION_SET_ROUTES',
}
